import { Component, OnInit } from '@angular/core';
import { BasicForm } from 'src/app/shared/basic-form';
import { Insurance, PolicyObject, PolicyOptions } from 'src/app/shared/insurance.model';
import * as _moment from 'moment';
import { getFromLocalStorage, setToLocalStorage } from 'src/app/shared/helpers';
import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';

@Component({
  selector: 'app-choose-policy',
  templateUrl: './choose-policy.component.html',
  styleUrls: ['./choose-policy.component.scss'],
  animations: [
    trigger('detailsState', [
      state('inactive', style({ height: '0px' })),
      state('active', style({ height: '*' })),
      transition('active <=> inactive', animate('200ms ease-in'))
    ]),
    trigger('iconState', [
      state('inactive', style({ transform: 'rotate(0)' })),
      state('active', style({ transform: 'rotate(180deg)' })),
      transition('active <=> inactive', animate('200ms ease-in'))
    ])
  ]
})
export class ChoosePolicyComponent extends BasicForm implements OnInit {
  slideOpen = {};
  isWarningBtn = true;
  insurance: Insurance;
  status: number;
  checkbox_checked: boolean;
  state: number;
  franchise: number;
  travel: any;
  duration: number;
  type: number;
  config: object;
  options: PolicyOptions[];
  openAccordion = [];
  openAccordion2 = [];
  openAccordion3 = [];
  showTab = 0;
  allExpanded = false;
  isClicked = false;
  desktop = true;
  travelAgeRange: number;
  age :number;
  scrollbar = { autoHide: true, track: 'simplebar-track' };
  tabToggle(index) {
    this.showTab = index;
  }

  limit = '5000';

  ngOnInit(): void {
    this.insurance = JSON.parse(localStorage.getItem('insurance'));
    this.formAlias = 'PolicyType';
    this.form = this.fb.group({
      currency: [],
      franchise: [false],
      covid: [false],
      policy: ['standart']
    })

    this.form.patchValue(this.formData);
    this.insurance = JSON.parse(localStorage.getItem('insurance'));

    this.options = this.config['POLICY_TYPES'];


    if (localStorage.getItem("type") === 'once') {
      // calculate days
      const duration = _moment
        .duration(
          _moment(this.policy.InsurancePeriod.endDate).diff(
            _moment(this.policy.InsurancePeriod.startDate)
          )
        )
        .asDays()  + 1;

      this.duration =  Math.ceil(duration);
    }

   
   
 
    if (localStorage.getItem('type') === 'multiple') {
      this.duration = parseInt(this.policy.InsuranceDays.days);
      const now = new Date();
      this.age = this.getAgeAfterTravel(this.policy.PersonalInfo.birthDate, this.addDays(now, 365));
    }
    else
    {
      this.age = this.getAgeAfterTravel(this.policy.PersonalInfo.birthDate, this.policy.InsurancePeriod.endDate);
    }
  
    // franchise
    switch (this.form.controls['franchise'].value) {
      case true:
        this.franchise = 1;
        break;
      case false:
        this.franchise = 2;
        break;
    }

    //travel type
    switch (this.policy.InsuranceType.type) {
      case 'once':
        this.type = 1;
        break;
      case 'multiple':
        this.type = 2;
        break;
    }

     if(this.age >64)
     {
      this.travelAgeRange = 5;
     }
     else
     {
      this.travelAgeRange = 3;
     }
     
    // final data
    this.travel = {
      travelTypeId: this.type,
      withCovid: this.form.controls['covid'].value,
      travelPeriodInDays: this.duration,
      travelFranchiseTypeId: this.franchise,
      listOfTravellerCountPerAgeRange: [
        {
          travellerAgeRangeId: this.travelAgeRange,
          travellerCount: 1
        }
      ],
    }

    this.aldagi.calculatePremiums(this.travel).subscribe(data => {
      this.options.map((p: PolicyOptions) => {
        const c = data.find(d => d.travelProductId === p.id);
        p['price'] = c.premium;
      });
    });

    this.form.valueChanges.subscribe(val => {
      console.log('calculation');
      console.log(getFromLocalStorage('policy'));
      // final data
      this.travel = {
        travelTypeId: this.type,
        withCovid: val.covid,
        travelPeriodInDays: this.duration,
        travelFranchiseTypeId: val.franchise ? 1 : 2,
        listOfTravellerCountPerAgeRange: [
          {
            travellerAgeRangeId: this.travelAgeRange,
            travellerCount: 1
          }
        ],
      }
      this.aldagi.calculatePremiums(this.travel).subscribe(data => {
        this.options.map((p: PolicyOptions) => {
          const c = data.find(d => d.travelProductId === p.id);
          p['price'] = c.premium;
        });
      });
    });

    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      this.desktop = false;
    }
  }

  changeSlide(index: number): void {
    this.slideOpen[index] = !this.slideOpen[index];
  }

  getChevronStyle(){
    if(this.slideOpen) {
        return { 'transform': 'rotate(0deg)' }
    } else {
        return { 'transform': 'rotate(180deg)' }
    }
}

  toggleState(p: PolicyOptions) {
    p.state = p.state === 'active' ? 'inactive' : 'active';
  }

  back() {
    this.stepService.prevStep();
  }

  onSubmit() {
    this.stepService.nextStep();
    setToLocalStorage('policy', this.formAlias, this.form.value);
    localStorage.setItem('insurance', JSON.stringify(this.insurance));
  }
  addDays(date, days) {
    const newDate = new Date(date.getTime() 
        + days * 24 * 60 * 60 * 1000);
    return newDate;
}

}
